var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PortalPageShell',{attrs:{"title":"Claim Manager","subtitle":_vm.$t('portal.claimManager')}},[_c('ManageClaim',{staticClass:"portal-page-fill",attrs:{"direction":_vm.direction,"sort":_vm.sort},on:{"updateSort":_vm.updateSort}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }